<template>
    <el-dialog
            :title="'添加角色'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="160px">
            <el-form-item label="请选择角色" prop="dataType">
                <el-select v-model="selectRoleId" placeholder="请选择角色"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in roleList"
                            :key="item.id"
                            :label="item.roleName"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                roleList:[],
                appId:'',
                selectRoleId:''
            }
        },
        methods: {
            resetForm() {
                this.$refs['dataForm'].resetFields();
            },
            init(roleList,appId) {
                this.visible = true
                this.$nextTick(() => {
                    this.resetForm()
                })
                this.selectRoleId=''
                this.roleList=[]
                this.roleList=roleList
                this.appId=appId
            },
            // 表单提交
            dataFormSubmit() {
                if(this.selectRoleId==='' || this.selectRoleId===undefined){
                    this.$message.error('请选择角色')
                    return
                }
                this.$http({
                    url: '/auth/application/addRole?appId='+this.appId+'&roleId='+this.selectRoleId,
                    method: 'post'
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-select{
        width: 100%;
    }
</style>
